/* eslint-disable max-params */
import { useEffect, useState } from 'react';
import { getActiveSectionsWithData } from '../../utils/helpers';
export default function useActiveSectionsWithData(sectionsResults, activeSections, sectionsRefs, query, podsData) {
    const [activeSectionsWithData, setActiveSectionsWithData] = useState([]);
    // Add to active sections the results data and refs when autocomplete results or recommendation results fetched
    useEffect(() => {
        const activeSectionsWithDataValue = getActiveSectionsWithData(activeSections, sectionsResults, sectionsRefs, podsData);
        if (activeSectionsWithDataValue.length || !query) {
            setActiveSectionsWithData(activeSectionsWithDataValue);
        }
    }, [activeSections, sectionsResults, sectionsRefs, query, podsData]);
    return activeSectionsWithData;
}
